import { useEffect, useRef, useState } from "react";
import { useProduct } from "@/lib/product";

const pad = (n) => String(n).padStart(2, "0");
const UNITS = [
  ["days", "Jours"],
  ["hours", "Heures"],
  ["minutes", "Min"],
  ["seconds", "Sec"],
];

export const Countdown = ({ prefix, compact = false }) => {
  const { product, offset, reload } = useProduct();
  const [now, setNow] = useState(() => Date.now() + offset);
  const fired = useRef(false);

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now() + offset), 1000);
    return () => clearInterval(id);
  }, [offset]);

  const diff = product ? Math.max(0, new Date(product.promo_end).getTime() - now) : 0;

  useEffect(() => {
    if (product?.promo_active && diff === 0 && !fired.current) {
      fired.current = true;
      reload();
    }
  }, [diff, product, reload]);

  if (!product?.promo_active) return null;

  const s = Math.floor(diff / 1000);
  const values = { days: Math.floor(s / 86400), hours: Math.floor((s % 86400) / 3600), minutes: Math.floor((s % 3600) / 60), seconds: s % 60 };

  if (compact) {
    return (
      <span data-testid={`${prefix}-countdown`} className="font-mono font-semibold tabular-nums">
        {values.days}j {pad(values.hours)}h {pad(values.minutes)}m {pad(values.seconds)}s
      </span>
    );
  }

  return (
    <div data-testid={`${prefix}-countdown`} className="flex gap-2 sm:gap-3">
      {UNITS.map(([k, label]) => (
        <div key={k} className="countdown-cell">
          <span data-testid={`${prefix}-countdown-${k}`} className="font-mono text-2xl sm:text-3xl font-semibold tabular-nums text-slate-900">
            {k === "days" ? values[k] : pad(values[k])}
          </span>
          <span className="text-[10px] sm:text-xs uppercase tracking-[0.16em] text-slate-500">{label}</span>
        </div>
      ))}
    </div>
  );
};
